import cn from 'classnames'
import type { ReactNode } from 'react'

import styles from './Collapsible.module.scss'

type CollapsibleProps = {
  open: boolean
  children: ReactNode
}

// A region whose height animates open/closed via the grid-template-rows trick.
function Collapsible({ open, children }: CollapsibleProps) {
  return (
    <div className={cn(styles['deposit-collapsible'], { [styles.open]: open })}>
      <div className={styles['deposit-collapsible-inner']}>{children}</div>
    </div>
  )
}

export default Collapsible
